import { query, mutation } from "gql-query-builder";
import { buildVariables } from "../libs/GraphQueryBuilder";
import {
  CreatePledgeMutationVariables,
  ModelSortDirection,
  PledgeType,
  UpdatePledgeMutationVariables,
  ListPledgesByUserIDQueryVariables,
  ModelPledgeFilterInput,
  ListPledgesByPollIDQueryVariables,
  ListHotPledgesByStatusQueryVariables,
  HotPollStatus,
} from "../API";
import API from "@aws-amplify/api";

export async function checkPledgedUserByPoll(userID, PollID) {
  const _variables: ListPledgesByUserIDQueryVariables = {
    userID,
    filter: {
      pollID: { eq: PollID },
      type: { eq: PledgeType.PLEDGE },
    },
  };
  const variables = buildVariables<ListPledgesByUserIDQueryVariables>(
    _variables,
    [
      { key: "userID", name: "ID!" },
      { key: "filter", name: "ModelPledgeFilterInput" },
      { key: "type", name: "PledgeType" },
    ]
  );
  const q = query({
    operation: "result: listPledgesByUserID",
    fields: [{ items: ["id"] }],
    variables,
  });
  const pledgedPolls: any = await API.graphql(q);
  if (pledgedPolls.data.result?.items?.length > 0) {
    return Promise.resolve(true);
  }
  return Promise.resolve(false);
}

export function listPledgedPollsByUser(userID: string, pollFields: any[]) {
  const _variables: ListPledgesByUserIDQueryVariables = {
    userID,
    filter: {
      type: { eq: PledgeType.PLEDGE },
    },
  };
  const variables = buildVariables<ListPledgesByUserIDQueryVariables>(
    _variables,
    [
      { key: "userID", name: "ID!" },
      { key: "filter", name: "ModelPledgeFilterInput" },
      { key: "type", name: "PledgeType" },
    ]
  );
  const q = query({
    operation: "result: listPledgesByUserID",
    fields: [{ items: [{ poll: pollFields }] }],
    variables,
  });
  return API.graphql(q);
}

export function listPledgedUsersByPoll(pollID: string, userFields: any[]) {
  const _variables: ListPledgesByPollIDQueryVariables = {
    pollID,
    filter: {
      type: { eq: PledgeType.PLEDGE },
    },
  };
  const variables = buildVariables<ListPledgesByPollIDQueryVariables>(
    _variables,
    [
      { key: "pollID", name: "ID!" },
      { key: "filter", name: "ModelPledgeFilterInput" },
    ]
  );
  const q = query({
    operation: "result: listPledgesByPollID",
    fields: [{ items: ["createdAt", { user: userFields }] }],
    variables,
  });
  return API.graphql(q);
}

// Creat pledge when user havent pledged a poll yet
export async function pledgePoll(pollID: string, userID: string) {
  const ops = createPledgeOperation(pollID, userID);
  return API.graphql(ops);
}

export function createPledgeOperation(pollID: string, userID: string) {
  const _variables: CreatePledgeMutationVariables = {
    input: {
      id: `${pollID}.${userID}`,
      pollID,
      userID,
      type: PledgeType.PLEDGE,
    },
  };
  const variables = buildVariables<CreatePledgeMutationVariables>(_variables, [
    { key: "input", name: "CreatePledgeInput!" },
  ]);

  return mutation({
    operation: "result: createPledge",
    fields: ["id"],
    variables,
  });
}

// withdraw a Pledge of a poll
export async function withdrawPledgePoll(
  fields: any[],
  pollID: string,
  userID: string,
  reason: string
) {
  const _variables: UpdatePledgeMutationVariables = {
    input: {
      id: `${pollID}.${userID}`,
      userID,
      pollID,
      type: PledgeType.WITHDRAW,
      reason,
    },
    condition: {
      type: { ne: PledgeType.WITHDRAW },
    },
  };
  const query = updatePledgeQuery(fields, _variables);
  await API.graphql(query);
}

export async function listHotPledges(nextToken?: string) {
  const _variables: ListHotPledgesByStatusQueryVariables = {
    status: HotPollStatus.VISIBLE,
    sortDirection: ModelSortDirection.DESC,
  };
  if (nextToken !== null) {
    _variables.nextToken = nextToken;
  }

  const variables = buildVariables<ListHotPledgesByStatusQueryVariables>(
    _variables,
    [
      { key: "status", name: "HotPollStatus" },
      { key: "sortDirection", name: "ModelSortDirection" },
    ]
  );

  const ops = query({
    operation: "result: listHotPledgesByStatus",
    variables,
    fields: [
      {
        items: [
          {
            poll: [
              "id",
              "title",
              "description",
              { image: ["bucket", "region", "key"] },
              "video",
              "status",
              "startTime",
              "endTime",
              "pledgePeriod1StartTime",
              "pledgePeriod1EndTime",
              "pledgePeriod2StartTime",
              "pledgePeriod2EndTime",
              { voteResults: [{ items: ["count"] }] },
            ],
          },
        ],
      },
      "nextToken",
    ],
  });

  return API.graphql(ops);
}

export function createPledgeQuery(
  fields: any[],
  _variables: CreatePledgeMutationVariables
) {
  const variables = buildVariables<CreatePledgeMutationVariables>(_variables, [
    { key: "input", name: "CreatePledgeInput!" },
    { key: "condition", name: "ModelPledgeConditionInput" },
  ]);

  return mutation({
    operation: "result: createPledge",
    fields,
    variables,
  });
}

export function updatePledgeQuery(
  fields: any[],
  _variables: UpdatePledgeMutationVariables
) {
  const variables = buildVariables<UpdatePledgeMutationVariables>(_variables, [
    { key: "input", name: "UpdatePledgeInput!" },
    { key: "condition", name: "ModelPledgeConditionInput" },
  ]);

  return mutation({
    operation: "result: updatePledge",
    fields,
    variables,
  });
}
